import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";

type Props = {
  formik: any;
  sectionId: number;
};

const Step10: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      visible: true,
      name: "familyGroup",
      questionData: questions[0],
      label:
        "¿Quienes conforman su grupo familiar primario? (familiares con los que convive actualmente bajo el mismo techo)",
      checkboxStyle: {
        minWidth: "200px",
        margin: "0 1.1rem",
        marginTop: "8px",
      },
      elementType: ElementType.Checkbox,
    },
    {
      key: 1,
      formik,
      visible: true,
      name: "familyGroupPosition",
      questionData: questions[1],
      label: "¿Cuál es su posición dentro del grupo familiar?",
      elementType: ElementType.Select,
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='center'>
        Cuéntenos sobre su familia
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step10;
